import React from 'react'
import { Button, Col, DatePicker, Input, Row, Select, Space, Tooltip } from 'antd';
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons";
import map from "lodash/map";
import get from "lodash/get";
import StaffAttendance from './staffAttendance';
import { getCurrentDateRange } from '../../utilities/report';
import dayjs from 'dayjs';
import { exportToExcel } from '../../utilities/pnlSummary';
import { REQUIRED_HEADERS_MONTHLY } from '../../constants/staffDetailManagement';

const StaffFilters = ({ setStaff, staffs, inputRef, config, toggleStaffModal, getCompanyStaff, filter }) => {
  return (
    <div className={`overflow-y-auto`}>
      <Row className='py-2'>
        <Col xs={24} md={24} className="flex flex-row justify-between mb-2">
          <Space>
            <Tooltip title="Download Sample Excel">
              <Button onClick={() => exportToExcel(REQUIRED_HEADERS_MONTHLY, get(staffs, "data"), {
                "S.N.": "id",
                "Staff Name": "name",
                "Staff Manager": 'manager.name',
                "Staff Manager ID": "manager.emp_id",
                "Staff Type": "staff_type.name",
                "Staff ID": 'emp_id',
                "Role": "role.name",
                "Salary/PH": "staff_salary.per_hour_salary",
              }, "staff.xlsx")} type="primary">
                <DownloadOutlined />
              </Button>
            </Tooltip>
            <Button
              type="primary"
              onClick={() => {
                toggleStaffModal();
              }}
            >
              Add Staff
            </Button>
            <StaffAttendance title="Import Staff" fileType='monthly' dateString={dayjs(get(staffs, "filters.date.0")).format("YYYY-MM")} filter={filter} config={config} updateData={() => getCompanyStaff(get(staffs, "filters"))} />
          </Space>
          <Space>
            <DatePicker
              value={dayjs(get(staffs, "filters.date.0"))}
              allowClear={false}
              onChange={(value, dateString) => {
                const dateRange = getCurrentDateRange("month", value);
                setStaff({
                  ...staffs,
                  filters: { ...get(staffs, 'filters'), date: dateRange },
                });
                getCompanyStaff({ from_date: get(dateRange, '0'), to_date: get(dateRange, "1") })
              }}
              picker="month"
              format={"MM-YYYY"}
            />
            <Input
              style={{
                width: 200,
              }}
              ref={inputRef}
              value={get(staffs, "filters.searchQuery")}
              onChange={(e) => {
                inputRef.current = undefined
                setStaff({
                  ...staffs,
                  filters: { ...get(staffs, 'filters'), searchQuery: e.target.value },
                });
              }}
              size="middle"
              placeholder="Search staff"
              onClear={() => {
                setStaff({
                  ...staffs,
                  filters: { ...get(staffs, 'filters'), searchQuery: undefined },
                });
              }}
              allowClear
              prefix={<SearchOutlined className="mr-2 text-gray-400" />}
            />
            <Select
              size="middle"
              value={get(staffs, "filters.role")}
              style={{
                width: 200,
              }}
              placeholder="Search Role"
              options={map(
                Object.values(get(config, "staff_roles", [])),
                (role) => ({
                  label: get(role, "name", ""),
                  value: get(role, "value", ""),
                })
              )}
              onClear={() => {
                setStaff({
                  ...staffs,
                  filters: { ...get(staffs, 'filters'), role: undefined },
                });
              }}
              onChange={(value) => {
                setStaff({
                  ...staffs,
                  filters: { ...get(staffs, 'filters'), role: value },
                });
              }}
              allowClear
            />

          </Space>
        </Col>
      </Row>
    </div>
  )
}

export default StaffFilters